// extracted by mini-css-extract-plugin
module.exports = {"modal":"Dialog_modal__3lf3Q","content":"Dialog_content__2hMJ-","dangerModal":"Dialog_dangerModal__2cHfp"};